import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import $ from 'jquery';
import Util from "../../streaming/Util";

/***CHECK FOR OUR BROWSER TYPE AND OSNAME  START HERE*/
import { isChrome as chrome, isSafari as safari, isMobileOnly as mobileOnly,isTablet as tablet, isAndroid as android, isIOS as ios,isFirefox as ff, isIE as ie,isEdge as edge, osName as osname, fullBrowserVersion as fbrowserversion, mobileVendor as mobvendor, deviceType, isIPad13 as ipad13} from "react-device-detect";

class AutoLogin extends Component {
  constructor() {
      super();
      this.state = {
          errors: {},
          redirectRouting:'',
          onDemand:false
      };
  }

  componentDidMount() {

		const { location } = this.props;
		if (location.search != '')
			{
				if ( location.search.indexOf('ref=signup') > 0 )
					{
						localStorage.setItem('deeplinkRef', 'signup');
					}
			}

      let error = false;

      // If logged in and user navigates to Login page, should redirect them to dashboard
      if (this.props.auth.isAuthenticated) {
        var localstoragedata=JSON.parse(localStorage.getItem('userData'));
        var localstoragesessionListdata=JSON.parse(localStorage.getItem('sessionList'));
        if(localstoragedata && localstoragedata.sessionData && ( localstoragedata.sessionData.id != undefined || localstoragedata.sessionData.ondemandId != undefined )){
          if (localstoragedata.onBoarding == 1) {
            this.props.history.push("/pre-screen");
          } else {
              this.props.history.push("/pre-screen");  
          }        
        } else if(localstoragesessionListdata && localstoragesessionListdata.sessionData && localstoragesessionListdata.sessionData[0] && localstoragesessionListdata.sessionData[0].id != undefined) {
          if (localstoragesessionListdata.onBoarding == 1) {
            this.props.history.push("/session-list");
          } else {
              this.props.history.push("/session-list");
          }
        }else {
          if ((localstoragedata !== null && localstoragedata.onBoarding == 1) || (localstoragesessionListdata !== null && localstoragesessionListdata.onBoarding == 1)) {
            this.props.history.push("/home");
          } else {
              this.props.history.push("/home");
          }
        }
        
      }
	  
	
      /****CHECK OSNAME BROWSER IF MOBILE OR TABLET */
      if(osname == "iOS" && ios == true && ipad13 == false) {
        error = true;
        $("#virdio_onboarding1").removeClass('d-none');
        $("#login-container").addClass('d-none');
      }

      if(osname == "Android" && android == true && tablet == false){
        error = true;
        $("#virdio_onboarding1").removeClass('d-none');
        $("#login-container").addClass('d-none');
      }

      if(mobileOnly === false && tablet === true && osname=="Mac OS") {
          window['ipad'] = true;
      }
      
      if(osname == "Windows" || osname == "Linux" || osname == "Ubuntu" || osname == "Mac OS") {
          if((ff == true) && (parseFloat(fbrowserversion) < 72) && !window.electron){
            error = true;
            $("#virdio_onboarding1").addClass('d-none');
            $("#virdio_onboarding6").removeClass('d-none');
          }

          if((chrome == true) && (parseFloat(fbrowserversion) < 79) && !window.electron){
            error = true;
            $("#virdio_onboarding1").addClass('d-none');
            $("#virdio_onboarding6").removeClass('d-none');
          }

          if((edge == true) && (parseFloat(fbrowserversion) < 78) && !window.electron){
            error = true;
            $("#virdio_onboarding1").addClass('d-none');
            $("#virdio_onboarding6").removeClass('d-none');
          }

          if (ie && !window.electron) {
            error = true;
            $("#virdio_onboarding1").addClass('d-none');
            $("#virdio_onboarding6").removeClass('d-none'); 
          }

          if (safari && (parseFloat(fbrowserversion) < 13) && !window.electron) {
            error = true;
            $("#virdio_onboarding1").addClass('d-none');
            $("#virdio_onboarding6").removeClass('d-none'); 
          }
      }
      
      if(osname == "iOS" && safari && parseInt(fbrowserversion) < 13)
      {
          error = true;
          $("#virdio_onboarding1").addClass('d-none');
          $("#virdio_onboarding6").removeClass('d-none');
      }

      if(osname == "Android" && deviceType == "mobile" && mobvendor == "Google") {
          error = true;
          this.setState({
            redirectRouting:"https://play.google.com/store/apps/details?id=mvvm.f4wzy.com.virdioApp"
          });
      }

      if(osname == "iOS" && deviceType == "mobile" && mobvendor == "Apple"){
          error = true;
          this.setState({
            redirectRouting:"https://apps.apple.com/us/app/virdio/id1489704718"
          });
      }

      if (!error) {
          let userId = parseInt(this.props.match.params.id);
          if (isNaN(userId)) {
              this.props.history.push("/login");
          } else if (this.props.match.params.ondemandId !== undefined) {
              let ondemandId = parseInt(this.props.match.params.ondemandId);
              if (isNaN(ondemandId)) {
                  this.props.history.push("/login");
              } else {
                  this.authenticate();
              }
          } else {
              this.authenticate();
          }
      }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isAuthenticated) {

          var localstoragedata            = JSON.parse(localStorage.getItem('userData'));

          if(localstoragedata && localstoragedata.onDemandData && localstoragedata.onDemandData.ondemandId != undefined && !localstoragedata.hasLiveAndOnDemand )
			{
				if( this.state.onDemand === true )
					{
						var storage = JSON.parse(localStorage.getItem('userData'));
						storage.sessionData = JSON.parse(JSON.stringify(storage.onDemandData));
						localStorage.setItem("userData", JSON.stringify(storage));
						this.props.history.push("/pre-screen");
					}
				else 
					{
						this.props.history.push("/pre-screen");
					}
			}
		 else if(localstoragedata && localstoragedata.sessionData && ( localstoragedata.sessionData.id != undefined ) && !localstoragedata.hasLiveAndOnDemand )
			{
				this.props.history.push("/pre-screen");
			}
          else if ( localstoragedata && localstoragedata.sessionData && !localstoragedata.hasLiveAndOnDemand )
          {
				let mainSessionArray;
				if ( localstoragedata.sessionData && localstoragedata.sessionData.length > 0 )
					{
						let sortedSessionData = localstoragedata.sessionData.sort(Util.sortByDate);
						mainSessionArray = sortedSessionData[0];
					}
				else
					{
						mainSessionArray = localstoragedata.sessionData;
					}
			  
              
              let joinDuration = localstoragedata.default.streamJoiningDefaultTime * 60000;
              var startDateTime = new Date(new Date(mainSessionArray.scheduleDate).getTime() - joinDuration);
              var timeLeft = Math.ceil(Math.round( (new Date(startDateTime).getTime() - new Date().getTime()) / 1000 ) / 60 );
              console.log('timeLeft - ', timeLeft);

              if ( timeLeft <= 0 && localstoragedata.totalSession < 2 )
              {
                  localstoragedata.sessionData = mainSessionArray;
                  localStorage.setItem("userData", JSON.stringify(localstoragedata));
                  this.props.history.push("/pre-screen");
              }
              else
              {
                  this.props.history.push("/home");
              }
          }
		  else
		  {
			  this.props.history.push("/home");
		  }
    }

    if (nextProps.errors && Object.keys(nextProps.errors).length > 0) {
        console.log('nextProps error ---- ', nextProps);
        localStorage.removeItem('deeplinkRef');
        this.props.history.push("/login/"+nextProps.errors);
    }
	
	  if ( JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).noPlan && JSON.parse(localStorage.getItem('userData')).noPlan === 1 )
		{
			 this.props.history.push("/login/");
		}
  }

authenticate() {
    const userData = {
        userId: this.props.match.params.id,  
        auth: this.props.match.params.token
    };

    if (this.props.match.params.ondemandId !== undefined) {
        this.setState({ onDemand: true });

        userData.onDemandId = this.props.match.params.ondemandId;
    }

    this.props.loginUser(userData);
};

render() {

  return (
      <div className="container">
        <div className="row">
          <div className="login-bg" id="login-container">
            <div className="login-box">
              <div className="col-md-7 col-lg-5 col-sm-6 text-light mx-auto">              
                <div className="col-12">
                  <img src="./images/login-logo.png" className="login-logo" />
                  <p className="login-tagline">Authenticating....</p>
                </div>
              </div>
            </div>
          </div>          
        </div>

      {/*******ADD OPEN POPUP FOR CHECK BROWSER AND OS COMPITABLITY START HERE */}
      <div className="onboarding-screen pr-0 model onboarding-modal d-none" id="virdio_onboarding1">       
            <div className="modal-dialog width-75 mx-auto modal-dialog-centered">
                <div className="modal-content px-md-5 py-3 position-relative radius-10">
                    <div className="modal-body mx-0 mx-md-4 pb-md-4 shadow-none round">
                      <h4 className="modal-title text-white text-center font-35 font-medium mb-2 mb-md-4">Virdio</h4> 

                      <p className="text-white font-24 text-center px-sm-4">Please click on the button below to download the Virdio Mobile App, which can be used to stream the class or as the Virdio Remote Control App.</p>
                      <div className="text-center mt-3 mt-md-5">

                       <button type="button" className="custom_btn11 mt-3 mx-3" data-toggle="modal" onClick={e=>{window.location.assign(this.state.redirectRouting)}}>Download Mobile App</button>
                      </div>
                    </div>                        
                    </div>
                </div>
            </div> 
            {/**CHECK BLROWSER TYPE MESSAGE **/}
            <div className="onboarding-screen pr-0 model onboarding-modal d-none" id="virdio_onboarding6">       
            <div className="modal-dialog width-75 mx-auto modal-dialog-centered">
                <div className="modal-content px-md-5 py-3 position-relative radius-10">
                    <div className="modal-body mx-0 mx-md-4 shadow-none round">
                      <h4 className="modal-title text-white text-center font-35 font-medium mb-1">Virdio</h4> 
                      <p className="text-white font-24 text-center px-sm-4">Your Browser is not supported by Virdio. For better experience, we recommend you to use any of the following:</p>
                      <table className="table table-bordered text-white ">
                        <tr>
                          <td>MacBook/iMac</td>
                          <td><a href="https://apps.apple.com/us/app/virdio/id1489704718" target="_blank">Virdio App</a> | <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a> - v 13 + | <a href="https://www.google.com/chrome/" target="_blank">Chrome</a> - v 79 + | <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> - v 72 +</td>
                        </tr>
                        <tr>
                          <td>Windows 10 </td>
                          <td><a href="https://www.google.com/chrome/" target="_blank">Chrome</a> - v 78 + | <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> - v 72 +| <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge</a> - v 79 +</td>
                        </tr>
                        <tr className="text-white">
													<td>iOS</td>
													<td><a href="https://apps.apple.com/us/app/virdio/id1489704718" target="_blank">Virdio App</a></td>
												</tr>
                        <tr className="text-white">
													<td>Android</td>
													<td><a href="https://play.google.com/store/apps/details?id=mvvm.f4wzy.com.virdioApp&hl=en" target="_blank">Virdio App</a></td>
													</tr>
                          <tr className="text-white">
													<td>Linux</td>
													<td><a href="https://www.google.com/chrome/" target="_blank">Chrome</a> - v 78 + | <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> - v 72 +| <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge</a> - v 79 +</td>
													</tr>
                      </table>
                      {/* <p className="text-white">Alternatively you can also dowload Virdio Mobile apps from marketplaces @  <a href="https://apps.apple.com/us/app/virdio/id1489704718"><b>iOS</b></a> | <a href="https://play.google.com/store?hl=en"><b>Android</b> </a></p> */}
                      <div className="text-center mt-3 mt-md-5 d-none">
                        <button type="button" className="custom_btn11 mt-3 mx-3" onClick={e=>{window.location.assign(this.state.redirectRouting)}}>yes</button>
                        <button type="button" className="custom_btn11 mt-3 mx-3" data-toggle="modal" data-target="#verdio_onboard">no</button>
                      </div>
                         
                    </div>                        
                    </div>
                </div>
            </div> 
            {/***END HERE***/}
      </div>
    );
  }
}

AutoLogin.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { loginUser }
)(AutoLogin);;